import { Text } from "@meditect/medibase-components";

export const SalesCannotSalePriceCannotBeLowerThanPurchasePriceError = () => {
  return <Text>Le prix de vente ne peut pas être inférieur au prix d'achat.</Text>;
};
